module.exports = __webpack_public_path__ + "img/time_management_en.e63b1610.svg";